import { EmptyState, FiEyeOff } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';

export const RestrictedSection = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t('sharedDigitalDossier.restrictedSection.title')}
      description={t('sharedDigitalDossier.restrictedSection.description')}
      icon={FiEyeOff}
      size="md"
    />
  );
};
